var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBusyBee(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 119.888,
    height: 105.686,
    viewBox: "0 0 119.888 105.686",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_102",
    "data-name": "Rectangle 102",
    width: 119.888,
    height: 105.686,
    transform: "translate(0 0)",
    fill: "#fef587"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_186",
    "data-name": "Group 186",
    transform: "translate(-38 1.001)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_185",
    "data-name": "Group 185",
    transform: "translate(38 -1.001)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3941",
    "data-name": "Path 3941",
    d: "M120.224,257.551c0,1.4.026,2.665-.006,3.926a17.316,17.316,0,0,1-1.131,5.651,12.022,12.022,0,0,1-7.546,7.434,19.767,19.767,0,0,1-11.307.555c-5.563-1.317-9.318-5.891-10.046-12.037a18.464,18.464,0,0,1-.1-4.536c.111-.86-.144-.845-.8-.573-3.536,1.463-6.96,3.159-10.365,4.9-9.277,4.732-18.072,10.167-25.548,17.53-1.091,1.074-2.272,2.056-3.362,3.171.206-.29.4-.589.62-.869a99.758,99.758,0,0,1,23.594-21.478,103.106,103.106,0,0,1,14.236-8.168,2.307,2.307,0,0,0,1.232-1.286C94.7,240,110.054,240.026,116.9,246.411a17.489,17.489,0,0,1,3.885,5.551,2.093,2.093,0,0,0,1.053,1.055,117.107,117.107,0,0,1,29.922,20.795,75.08,75.08,0,0,1,8.566,9.791.708.708,0,0,1,.135.389c-11.121-12.279-25.315-19.832-40.236-26.441",
    transform: "translate(-45.192 -218.807)",
    fill: "#fef587"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3942",
    "data-name": "Path 3942",
    d: "M780.83,428.406a.686.686,0,0,1,.608.114,152.773,152.773,0,0,1,23.785,14.5c5.8,4.454,11.029,9.479,14.745,15.883a20.923,20.923,0,0,1,2.653,6.359c.525,2.63-.271,4.047-2.82,4.931a16.643,16.643,0,0,1-8.174.308,34.467,34.467,0,0,1-7.874-2.431c-.313-.13-.629-.252-.978-.391a19.468,19.468,0,0,1-.992,3.324c-.924,1.921-2.136,2.439-4.123,1.668a17.085,17.085,0,0,1-5.6-3.812,45.7,45.7,0,0,1-10.213-15.515A94.609,94.609,0,0,1,777.9,441.5a1.767,1.767,0,0,1,.216-1.536,19.011,19.011,0,0,0,2.716-10.863c-.007-.234,0-.468,0-.694",
    transform: "translate(-702.885 -387.105)",
    fill: "#fef587"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3943",
    "data-name": "Path 3943",
    d: "M41.947,431.7a18.584,18.584,0,0,0,2.556,8.807,2.639,2.639,0,0,1,.306,2.22A69.769,69.769,0,0,1,36.647,462.4,30.986,30.986,0,0,1,26.8,472.685c-3.491,2.12-5.4,1.292-6.347-2.678-.38-1.587-.38-1.587-1.927-.927a27.248,27.248,0,0,1-11.3,2.563,13.887,13.887,0,0,1-4.166-.678c-2.644-.887-3.524-2.477-2.845-5.19a24.078,24.078,0,0,1,3.045-6.755,57.553,57.553,0,0,1,14.486-15.3,141.058,141.058,0,0,1,19.975-12.436c1.1-.579,2.213-1.117,3.3-1.718.685-.38,1.143-.577.937.549a10.146,10.146,0,0,0-.013,1.583",
    transform: "translate(0 -387.916)",
    fill: "#fef587"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3944",
    "data-name": "Path 3944",
    d: "M383.959,24.7a8.158,8.158,0,0,1,2.075-9.7,10.942,10.942,0,0,1,2.637-1.8c.5-.239.673-.48.343-1.007-.566-.9-1.083-1.839-1.613-2.765a2.149,2.149,0,0,0-1-.853Q380.694,5.792,375,2.985c-.124-.061-.251-.114-.375-.174Q372.9,1.968,373.5.739c.391-.808,1.154-.964,2.315-.4,4.09,1.978,8.169,3.98,12.259,5.959a3.163,3.163,0,0,1,1.388,1.335c.722,1.253,1.477,2.487,2.174,3.754a.769.769,0,0,0,1.068.429,16.485,16.485,0,0,1,9.275-.008c.655.187.961.01,1.187-.554a11.983,11.983,0,0,1,7.4-6.944c2.726-1.032,5.286-2.5,7.921-3.776,1.578-.762,2.238-.713,2.667.189.444.932.06,1.522-1.46,2.259-3.344,1.622-6.663,3.3-10.043,4.845a6.316,6.316,0,0,0-3.27,3.068c-.911,1.848-1,1.806.739,2.933,3.678,2.39,5.192,6.216,4.013,10.058-.21.683-.414.807-1.026.339-7.056-5.4-18.094-5.642-25.372-.014-.24.186-.511.331-.77.5",
    transform: "translate(-337.38 0.001)",
    fill: "#fef587"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3945",
    "data-name": "Path 3945",
    d: "M440.032,757.9a32.723,32.723,0,0,1-17.079-4.394c-2.784-1.676-2.773-1.7-1.689-4.715.278-.772.415-1.927.957-2.182.575-.271,1.341.706,2.065,1.067,11.167,5.568,22.17,5.452,32.975-.971.594-.353.77-.306.969.332.379,1.214.784,2.425,1.269,3.6a1.248,1.248,0,0,1-.555,1.716,29.1,29.1,0,0,1-11.722,4.875,34.2,34.2,0,0,1-7.189.673",
    transform: "translate(-380.071 -674.575)",
    fill: "#fef587"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3946",
    "data-name": "Path 3946",
    d: "M461.336,615.164a17.73,17.73,0,0,0,7.211,3.6c6.114,1.414,12.037,1.089,17.617-2.08.209-.119.412-.251.613-.384,1.476-.979,1.445-.97,1.961.7a44.953,44.953,0,0,0,1.578,4.585c.449,1.04.161,1.459-.759,1.969a31.673,31.673,0,0,1-29.748-.1c-.749-.415-.936-.809-.6-1.619a45.771,45.771,0,0,0,2.126-6.672",
    transform: "translate(-414.827 -555.904)",
    fill: "#fef587"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3947",
    "data-name": "Path 3947",
    d: "M406.726,847.653c10.363,8.609,29.848,9.348,41.539.035.13,2.651-.017,5.025-2.4,6.751a31.676,31.676,0,0,1-36.331.281c-2.547-1.747-3.024-4.142-2.806-7.066",
    transform: "translate(-367.503 -765.997)",
    fill: "#fef587"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3948",
    "data-name": "Path 3948",
    d: "M454.095,975.412c10.875,6.347,21.713,6.157,32.629-.153a18.079,18.079,0,0,1-3.581,5,21.95,21.95,0,0,1-10.821,6.5,10.024,10.024,0,0,1-5.682-.427,23.015,23.015,0,0,1-12.407-10.367c-.1-.159-.276-.326-.138-.554",
    transform: "translate(-410.306 -881.31)",
    fill: "#fef587"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3949",
    "data-name": "Path 3949",
    d: "M334.484,245.631c-1.059.546-1.981,1-2.878,1.493-.4.223-.637.086-.867-.23a43.368,43.368,0,0,1-5.187-8.907,3.076,3.076,0,0,1-.194-.7c-.065-.414-.132-.922.29-1.119.462-.216.616.315.819.6a59.525,59.525,0,0,0,7.171,8.126c.244.236.513.445.846.731",
    transform: "translate(-293.972 -213.376)",
    fill: "#fef587"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3950",
    "data-name": "Path 3950",
    d: "M837.413,237.536c-.1.28-.262.844-.5,1.375a44.932,44.932,0,0,1-4.621,7.918c-.429.6-.824.869-1.49.337a5.957,5.957,0,0,0-.991-.55c-1.432-.746-1.43-.742-.281-1.816a60.1,60.1,0,0,0,6.833-7.856c.2-.264.369-.67.788-.5.318.128.351.482.26,1.094",
    transform: "translate(-748.871 -213.629)",
    fill: "#fef587"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBusyBee);
export default __webpack_public_path__ + "static/media/busy-bee.9cb9632b32514c4fb905a472cb63a812.svg";
export { ForwardRef as ReactComponent };